var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', [_c('el-header', {
    attrs: {
      "height": "auto"
    }
  }, [_c('el-form', {
    attrs: {
      "inline": "inline",
      "label-suffix": ":"
    }
  }, [_c('city-select', {
    model: {
      value: (_vm.city),
      callback: function($$v) {
        _vm.city = $$v
      },
      expression: "city"
    }
  }), _c('el-form-item', {
    attrs: {
      "label": "时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "value-format": "yyyy-MM-dd 00:00:00",
      "clearable": false,
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.timeRange),
      callback: function($$v) {
        _vm.timeRange = $$v
      },
      expression: "timeRange"
    }
  })], 1), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "action",
      rawName: "v-action",
      value: ("datacenter_bike_table"),
      expression: "`datacenter_bike_table`"
    }],
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "disabled": !_vm.city || _vm.timeRange.length === 0,
      "loading": _vm.searching
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "action",
      rawName: "v-action",
      value: ("datacenter_bike_export"),
      expression: "`datacenter_bike_export`"
    }],
    attrs: {
      "type": "primary",
      "icon": "el-icon-download",
      "disabled": !_vm.city || _vm.timeRange.length === 0
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("导出")])], 1)], 1)], 1), _c('el-main', [_c('grid', {
    ref: "grid",
    attrs: {
      "remoteMethod": _vm.getTableData,
      "dispaly-pagination": false
    }
  }, [(_vm.__action(_vm.table.day)) ? _c('el-table-column', {
    attrs: {
      "prop": "day",
      "label": "时间",
      "min-width": "130"
    }
  }) : _vm._e(), (_vm.__action(_vm.table.cityName)) ? _c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "label": "城市名",
      "min-width": "130"
    }
  }) : _vm._e(), (_vm.__action(_vm.table.serveCount)) ? _c('el-table-column', {
    attrs: {
      "prop": "serveCount",
      "label": "累计投放车辆数",
      "min-width": "130"
    }
  }) : _vm._e(), (_vm.__action(_vm.table.workingCount)) ? _c('el-table-column', {
    attrs: {
      "prop": "workingCount",
      "label": "当日运营车辆数",
      "min-width": "130"
    }
  }) : _vm._e(), (_vm.__action(_vm.table.successOrderCount)) ? _c('el-table-column', {
    attrs: {
      "prop": "successOrderCount",
      "label": "当日完成订单数",
      "min-width": "130"
    }
  }) : _vm._e(), (_vm.__action(_vm.table.freeOrderCount)) ? _c('el-table-column', {
    attrs: {
      "prop": "freeOrderCount",
      "label": "当日免费订单数",
      "min-width": "130"
    }
  }) : _vm._e(), (_vm.__action(_vm.table.accumulativeRegistration)) ? _c('el-table-column', {
    attrs: {
      "prop": "accumulativeRegistration",
      "label": "累计注册用户数",
      "min-width": "130"
    }
  }) : _vm._e(), (_vm.__action(_vm.table.accumulativeActive)) ? _c('el-table-column', {
    attrs: {
      "prop": "accumulativeActive",
      "label": "累计激活用户数",
      "min-width": "130"
    }
  }) : _vm._e(), (_vm.__action(_vm.table.active)) ? _c('el-table-column', {
    attrs: {
      "prop": "active",
      "label": "当日激活用户数",
      "min-width": "130"
    }
  }) : _vm._e(), (_vm.__action(_vm.table.avgUseCount)) ? _c('el-table-column', {
    attrs: {
      "prop": "avgUseCount",
      "label": "车均使用次数",
      "min-width": "130"
    }
  }) : _vm._e(), (_vm.__action(_vm.table.useCountLessThen3)) ? _c('el-table-column', {
    attrs: {
      "prop": "useCountLessThen3",
      "label": "单车翻台低于3次",
      "min-width": "130"
    }
  }) : _vm._e(), (_vm.__action(_vm.table.useCountEqualOrGreaterThen3)) ? _c('el-table-column', {
    attrs: {
      "prop": "useCountEqualOrGreaterThen3",
      "label": "单车翻台高于3次",
      "min-width": "130"
    }
  }) : _vm._e()], 1)], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f654ad44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f654ad44","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataCenter/operation.vue
// module id = hVXZ
// module chunks = 1